import smooth from 'chaikin-smooth';

const smoothPath = (coordinaters, count = 0) => {
  const c = smooth(coordinaters);
  const counter = count;
  return counter !== 0 ? smoothPath(c, count - 1) : c;
};

export default smoothPath;